<template>
    <!--review distribution-->
    <div class="yotpo-star-distribution-wrapper">
        <div class="yotpo-distribution-rows" role="radiogroup">
            <div class="yotpo-distribution-row " role="radio" tabindex="0" aria-checked="false" aria-label="5 star ratings">
                <div class="yotpo-star-distribution-score-value">5</div>
                <div class="yotpo-star-distribution-bar">
                    <div class="yotpo-star-distribution-bar-score"  :style="{width: fiveStarPercentage + '%'}"></div>
                </div>
            </div>   
            <div class="yotpo-distribution-row empty-row" role="radio" tabindex="0" aria-checked="false" aria-label="4 star ratings">
                <div class="yotpo-star-distribution-score-value">4</div>
                <div class="yotpo-star-distribution-bar">
                    <div class="yotpo-star-distribution-bar-score"  :style="{width: fourStarPercentage + '%'}"></div>
                </div> 
            </div>   
            <div class="yotpo-distribution-row empty-row" role="radio" tabindex="0" aria-checked="false" aria-label="3 star ratings">
                <div class="yotpo-star-distribution-score-value">3</div>
                <div class="yotpo-star-distribution-bar">
                    <div class="yotpo-star-distribution-bar-score" :style="{width: threeStarPercentage + '%'}"></div>
                </div> 
            </div>   
            <div class="yotpo-distribution-row empty-row" role="radio" tabindex="0" aria-checked="false" aria-label="2 star ratings"> 
                <div class="yotpo-star-distribution-score-value">2</div> <div class="yotpo-star-distribution-bar">
                    <div class="yotpo-star-distribution-bar-score" :style="{width: twoStarPercentage + '%'}"></div>
                </div>
            </div>
            <div class="yotpo-distribution-row empty-row" role="radio" tabindex="0" aria-checked="false" aria-label="1 star ratings">
                <div class="yotpo-star-distribution-score-value">1</div>
                <div class="yotpo-star-distribution-bar">
                    <div class="yotpo-star-distribution-bar-score" :style="{width: oneStarPercentage + '%'}"></div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script src="./ctrl-review-distribution.js"></script>